module.exports = __webpack_public_path__ + "img/106ne.06ed7f47.svg";